<template>
  <section class="form">
    <card-component title="Download Learner Reports" icon="ballot">
      <div>
        <p>
          Your current school & grade has
          <strong>{{ this.totalLearners() }}</strong> learners.
        </p>
        <p>
          These will be sent for report processing and all learners with a
          result in at least 1 thread of the selected subject should get a
          report.
        </p>
        <p>
          The reports will be zipped and the download link will be sent to your
          registered email address.
        </p>
      </div>
      <div>
        <form @submit.prevent="submit">
          <p>Project: {{ this.project() }}</p>
          <p>School: {{ this.school() }}</p>
          <p>Subject: {{ this.subject() }}</p>
          <p v-if="this.grade()">Grade: {{ this.grade() }}</p>
          <!-- <p v-if="this.class()">Class: {{ this.class() }}</p> -->
          <b-field>
            <div class="control">
              <b-button
                id="submitBtn"
                type="is-primary is-success"
                @click="submit()"
                v-html="'Process Reports'"
                :disabled="submitDisabled"
              />
            </div>
          </b-field>
        </form>
      </div>
    </card-component>
  </section>
</template>

<script>
import CardComponent from "@/components/CardComponent";
import mapValues from "lodash/mapValues";
import { mapState, mapActions, mapGetters } from "vuex";
import { ToastProgrammatic as Toast } from "buefy";

export default {
  name: "BulkLearnerReportsComponent",
  components: {
    CardComponent
  },
  mounted() {},
  watch: {
    getCurrentGradeIndex(value) {
      //show the submit button if it's disabled
      if (this.submitDisabled === true) {
        this.showHide();
      }
    }
  },
  data() {
    return {
      isLoading: false,
      submitDisabled: false
    };
  },
  computed: {
    ...mapState({
      user: "user",
      projects: state => state.globalStore.projects,
      schools: state => state.filterLists.schools,
      activeParams: state => state.globalStore.activeFilterParams,
      filterValues: state => state.globalStore.filterLists,
      reflectiveData: state => state.globalStore.reflectiveData
    }),
    ...mapGetters({
      getCurrentGradeIndex: "globalStore/getCurrentGradeIndex"
    })
  },
  methods: {
    ...mapActions({
      processReports: "adminStore/processReports",
      loading: "SET_SCREEN_LOADING"
    }),
    showHide() {
      this.submitDisabled = !this.submitDisabled;
    },
    async submit(formData) {
      const params = {
        project: this.project(),
        school: this.school(),
        subject: this.subject(),
        grade: this.grade()
        // class: this.class()
      };
      const response = await this.processReports(params);
      const msgType = !response ? "is-danger" : "is-success";
      this.$buefy.toast.open({
        message: `Your learner reports have been sent for processing. Please check your email inbox in a few minutes for the download link.`,
        type: msgType,
        duration: 8000
      });
      // this.showHide();
    },
    project() {
      return this.activeParams.project;
    },
    school() {
      return this.activeParams.school;
    },
    subject() {
      return this.activeParams.currentSubject;
    },
    grade() {
      return this.activeParams.grade;
    },
    class() {
      return this.activeParams.class;
    },
    totalLearners() {
      const learners = this.reflectiveData.filter(
        user => user.grade == this.grade() && user.school == this.school()
      );
      if (learners) {
        return learners.length;
      }
      return 0;
    }
  }
};
</script>
